export default "__VITE_ASSET__18ebe244__"